// ?use_ios_ui — whether the Android app runs the iOS 0.7.0 UI. ON by default
// since 2026-10-19 (dev: "default ON for all Android"); an explicit 0 / false
// / off / no turns it off — the escape hatch back to the shipped Android UI.

export const USE_IOS_UI_PARAM = 'use_ios_ui'

const OFF_VALUES = new Set(['0', 'false', 'off', 'no'])

export function resolveUseIosUi(params: URLSearchParams): boolean {
  const raw = params.get(USE_IOS_UI_PARAM)
  return raw == null || !OFF_VALUES.has(raw.trim().toLowerCase())
}
